import { post } from "helpers/api_helper";
import * as URL from "helpers/url_helper"

export const getAddress = data => post(URL.GET_ADDRESS, data);
